<template>
  <div>
    <el-form  :model="params" ref="searchRef">
      <!-- eslint-disable-next-line vue/no-unused-refs -->
      <QS-search maxLine="1" ref="BLM-search">
        <el-form-item prop="id" label="采购子订单ID">
          <el-input
            v-number:integer="18"
            v-model="params.id"
            placeholder="请输入采购子订单ID"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 车牌号 -->
        <el-form-item prop="carId" label="车牌号">
          <el-select
            filterable
            clearable
            remote
            placeholder="请输入"
            :filter-method="getCarNo"
            v-model="params.carId"
            @change="selectCarNo"
          >
            <el-option
              v-for="item in carNoList" :key="item.id"
              :label="item.plateNo"
              :value="item.id"

            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="providerId"
          label="车源方:"
        >
          <el-select
            v-model="params.providerId"
            placeholder="请选择"
            clearable
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in carProviderList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="gmtTime" label="订单创建时间">
          <el-date-picker
            v-model="params.gmtTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门" prop="deptIdList">
          <DeptSelect v-model="params.deptIdList" :multiple="true" :isAll="false" />
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button :loading="loading" type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="reset()">重置</el-button>
          </el-form-item>
          <el-form-item>
            <export
              exportTemplate="PurchaseSonOrder"
              filename="采购子订单.xlsx"
              :params="exportParams"
            />
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <QS-common-table
    class="mt16"
      :loading="loading"
      :data="list"
      :columns="headData"
      :pagination="paginationData"
      @change="paginationChange"
    ></QS-common-table>
  </div>
</template>
<script>
import { FuzzySearch, getCarProvider, returnCarCheck } from '@/api/domain/cars.js'
import { getSubOrderList } from '@/api/domain/purchase.js'
import config from './config'

export default {
  props: {
    state: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      carProviderList: [],
      headData: config.call(this).headData,
      params: {
        id: '',
        carId: '',
        providerId: '',
        gmtTime: '',
        state: '',
        deptIdList: [],
      },
      list: [],
      loading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      carNoList: [], // 车牌号列表
    }
  },
  created() {
    this.headData.unshift({
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '子订单ID',
        width: 120,
      },
      render: ({ row }) => {
        if (!this.judgePermission('purchase_new_order_list_sub_detail')) {
          return row.id
        }
        return <el-button type="text" onClick={() => { this.toOrderDetail(row) }}>{row.id}</el-button>
      },
    })
    this.getCarProvider()
    this.getList()
  },
  computed: {
    // 导出参数
    exportParams() {
      return {
        ...this.params,
        createTimeStart: this.params.gmtTime ? this.params.gmtTime[0] : '',
        createTimeEnd: this.params.gmtTime ? this.params.gmtTime[1] : '',
        state: this.state === '1' ? '' : this.state,
      }
    },
  },
  watch: {
    state() {
      this.reset()
    },
  },
  methods: {
    // 退车核算
    // eslint-disable-next-line vue/no-unused-properties
    exitCarSettle(row) {
      const params = { orderId: row.id }
      returnCarCheck(params).then((res) => {
        if (res?.data === true) {
          this.$router.push({
            path: '/purchaseOrder/sonOrderMange/detail',
            query: {
              type: 5, // 跳转到那个tab
              orderType: 'purchaseSonOrder', // 来自采购子订单列表
              id: row.id,
            },
          })
        }
      })
    },
    // 车辆详情
    // eslint-disable-next-line vue/no-unused-properties
    toCarDetail(row) {
      this.$router.push({
        path: '/vehicle/vehicleManage/detail',
        query: {
          id: row.carId,
          plateNo: row.plateNo,
          source: 'detail',
        },
      })
    },
    // 订单详情
    toOrderDetail(row) {
      this.$router.push({
        path: '/purchaseOrder/sonOrderMange/detail',
        query: {
          orderType: 'purchaseSonOrder',
          id: row.id,
        },
      })
    },
    search() {
      this.paginationData.pageNum = 1
      this.getList()
    },
    getList() {
      this.loading = true
      getSubOrderList({
        ...this.params,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
        createTimeStart: this.params.gmtTime ? this.params.gmtTime[0] : '',
        createTimeEnd: this.params.gmtTime ? this.params.gmtTime[1] : '',
        state: this.state === '1' ? '' : this.state,
      }).then((res) => {
        this.loading = false
        if (res.code !== 1) return
        this.list = res.data.items || []
        this.paginationData.total = res.data.totalNum || 0
      }).catch(() => {
        this.loading = false
      })
    },
    reset() {
      this.$refs.searchRef?.resetFields()
      this.paginationData.pageNum = 1
      this.paginationData.pageSize = 10
      this.getList()
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getList()
    },
    // 获取车源方列表
    async getCarProvider() {
      try {
        const { code, data } = await getCarProvider({
          serviceType: 0,
        })
        if (code === 1) {
          this.carProviderList = data.items
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 车牌号搜索
    async getCarNo(val) {
      if (!val || val.length < 4) {
        this.carNoList = []
        return
      }
      // state（车辆状态）:  1-全部车辆 2-运营中车辆 3-待租车辆 4-待采购车辆
      const { data } = await FuzzySearch({ state: 1, plateNo: val })
      this.carNoList = data || []
    },
    // 车牌号选择
    selectCarNo(val) {
      if (!val) this.carNoList = []
    },
  },
  activated() {
    this.getList()
  },
}
</script>
<style scoped lang="scss">
</style>
